import React, { Suspense, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import staticRoutes from "../routes";
// import DataView from '../views/dashboard/NewComponents/DataView';
// import dynamicRoutes from './routes/dynamicRoutes';
// import CustomLoader from './components/CustomLoader';
const HomeNew = React.lazy(() => import('../views/dashboard/NewComponents/HomeNew'));
const DataView = React.lazy(() => import('../views/dashboard/NewComponents/DataView'));
import { UserContext } from '../Contexts/UserContext';
import Loader from './shared/Loader';
import BroadcastBanner from './shared/BroadCast/BroadCastBanner';
import SkeletonPage from './shared/skeletons/SkeletonPage';
import WelcomePage from 'src/views/pages/WelcomePage/WelcomePage';

const AppContent = ({ AllowedRoutes, currentMessage, sideBarFlag }) => {
  const { contextUserData } = useContext(UserContext);

  // Ensure dynamicRoutes is always an array
  let dynamicRoutes = contextUserData?.RegisteringRoutes?.length > 0 ? contextUserData.RegisteringRoutes : [];





  dynamicRoutes = dynamicRoutes?.length > 0 ? dynamicRoutes.map((route) => {
    console.log("route.component:", route.component)

    return {
      ...route,
      exact: Boolean(route.exact),
      component:
        route.component === "HomeNew"
          ? React.lazy(() => import('../views/dashboard/NewComponents/HomeNew'))
          : route.component === "Dataview"
            ? React.lazy(() => import('../views/dashboard/NewComponents/DataView'))
            : route.component === "DirectReport"
              ? React.lazy(() => import('../views/dashboard/NewComponents/DirectReport'))
              : null
    };
  }) : [];

  const allRoutes = [...staticRoutes, ...dynamicRoutes];


  const renderRoute = (route, hasAccess, props) =>
    hasAccess ? (
      <route.component
        {...props}
        sideBarFlag={Boolean(sideBarFlag)}
        shouldCardRender={Boolean(route.shouldCardRender)}
        shouldChartRender={Boolean(route.shouldChartRender)}
        sourceName={route.sourcename}
        databasepaging={route.databasepaging}
      />
    ) : (
      <Redirect to="/unauthorized" />
    );
  console.log("see this bro:", contextUserData)
  if (contextUserData?.ShowWelcomePage) {
    return <WelcomePage />;
  }

  return (
    AllowedRoutes?.length > 0 && (<>

      {/* <BroadcastBanner currentMessage={currentMessage} /> */}
      <Suspense fallback={<SkeletonPage />}>

        <Switch>
          {allRoutes.map((route, idx) => {
            const hasAccess = AllowedRoutes.includes(route.path);

            return (
              <Route
                key={idx}
                path={route.path.trim()}
                exact={route.exact}
                render={(props) => renderRoute(route, hasAccess, props)} // Fixed: returning the result of renderRoute
              />
            );
          })}
        </Switch>

      </Suspense>

    </>

    )
  );
};

export default React.memo(AppContent);
